import React, { useContext, useEffect, useState } from "react";
import "./New.scss";
import HomeIcon from "./assets/new_imgs/Group 38660.png";
import SearshIcon from "./assets/new_imgs/Path 445.png";
import CartIcon from "./assets/new_imgs/Path 444.png";
import WhatsappIcon from "./assets/new_imgs/Group 38659.png";
import MenuIcon from "./assets/new_imgs/Group 38658.png";
import { Link, useLocation, useParams } from "react-router-dom";
import axios from "./axios";
import { ShowCheckout } from "./API/CheckoutAPI";
import { ThemeContext } from "./context/ThemeContext";

const NewFooter = () => {
  const location = useLocation();
  const { setTheme } = useContext(ThemeContext);
  const room_qr = localStorage.getItem("room_uuid_before_redirect");
  const lang = sessionStorage.getItem("lang");
  const region = process.env.REACT_APP_SERVER_REGION;
  const [isWhatsapp, setIsWhatsapp] = useState(false);

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  let flattenedArray;
  let cart_count = 0;
  let check;

  if (room_uuid) {
    const { data, isLoading } = ShowCheckout(room_uuid);

    if (!isLoading) {
      check = data?.data?.data;

      const tempItems = check?.order?.map((order) => {
        return order?.items.map((aa) => aa);
      });
      const combo_meal = check?.order[0]?.combo_meals?.length || 0;
      if (tempItems) {
        flattenedArray = [].concat(...tempItems);
        cart_count =
          flattenedArray?.length == 0
            ? 0
            : flattenedArray
                ?.map((item) => item?.quantity)
                .reduce((acc, curr) => (acc += curr));
        cart_count = cart_count + combo_meal;
      }
    }
  }

  useEffect(() => {
    const getData = () => {
      axios.get(`/${room_uuid}/footer/qr-code`).then((res) => {
        const data = res.data.data;
        localStorage.setItem("room_number", data?.room_number);
        localStorage.setItem("currency", data?.currency || "AED");
        localStorage.setItem("color", data?.color);

        localStorage.setItem("new_design", data?.use_new_design);
        setTheme(data?.use_new_design);

        setIsWhatsapp(data?.whatsapp_enabled);
        localStorage.setItem("tax_inclusive", data?.tax_inclusive);
        localStorage.setItem("show_prices", data?.show_prices);
        localStorage.setItem("has_extra_services", data?.has_extra_services);
        localStorage.setItem("room_number", data?.room_number);
        localStorage.setItem("businessType", data.businessType);
        localStorage.setItem("countryCode", data?.country_code || "ae");
        localStorage.setItem("welcome_message", data?.welcome_message);
        localStorage.setItem("business_id", data?.business_id);
        localStorage.setItem("room_type", data?.room_type);

        if (data?.host_id || data?.hostId) {
          localStorage.setItem(
            "chat_host_id",
            String(data.host_id || data.hostId),
          );
        }

        const sessionInfo = {
          "Room UUID": room_qr,
          "Session ID": room_uuid,
          "Business Name": data?.business_name,
          "Room Number": data?.room_number,
          "Location Type": data?.room_type,
          "Business ID": data?.business_id,
          "Server Region": region,
          Language: lang,
          Platform: "Web",
          utm_source: "",
          utm_medium: "",
          utm_campaign: "",
        };
        localStorage.setItem("mixpannel_data", JSON.stringify(sessionInfo));

        if (data?.color) {
          document.documentElement.style.setProperty("--color", data?.color);
          document.documentElement.style.setProperty(
            "--color_t",
            `${data?.color}b3`,
          );

          document.documentElement.style.setProperty(
            "--header_color",
            data?.header_color,
          );
        }
      });
    };
    if (room_uuid) {
      getData();
    }
  }, [room_uuid, lang, region, room_qr, setTheme]);

  const params = useParams();
  return (
    <div className="new_footer">
      <ul>
        <li>
          <Link to={`/${params.room_uuid}/menu`}>
            <img src={MenuIcon} alt="" />
          </Link>
        </li>
        <li>
          <Link to={`/${params.room_uuid}/search`}>
            <img src={SearshIcon} alt="" />
          </Link>
        </li>
        <li>
          <Link to={`/${params.room_uuid}/qr-code`}>
            <img src={HomeIcon} alt="" />
          </Link>
        </li>
        <li>
          <Link to={`/${params.room_uuid}/cart`}>
            <img src={CartIcon} alt="" />
            <span>{cart_count}</span>
          </Link>
        </li>
        {isWhatsapp && (
          <li>
            <Link to={`/${params.room_uuid}/chat`} aria-label="Chat with Host">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: '2px' }}>
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                <circle cx="8" cy="11.5" r="1.5" fill="#666" stroke="none" />
                <circle cx="12" cy="11.5" r="1.5" fill="#666" stroke="none" />
                <circle cx="16" cy="11.5" r="1.5" fill="#666" stroke="none" />
              </svg>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default NewFooter;
